<template>
  <div class="help">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 header-text">
          <h1>{{ $t('views.help.helpAndFrequently') }}<span class="blue">{{ $t('views.help.helpAndFrequently2') }}</span></h1>
            <div class="row bottom-stepper">
              <div class="col-12">
                <b-tabs navWrapperClass="income-tabs" pills="" class="w-100">
                  <b-tab v-for="i in helpCategories" :key="'tab-' + i.id" :title="$t(i.title)" :active="i.id===helpStep" @click="setHelpCategory(i.id)"></b-tab>
                </b-tabs>
              </div>
            </div>
          <div class="income-box">
            <div class="help-section" v-show="helpStep===1">
              <div role="tablist">
                <b-card no-body class="mb-1" v-for="(help, index) in helpContent.general" :key="index">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="('general-help-'+index)" v-html="$t(help.question)"></b-button>
                  </b-card-header>
                  <b-collapse v-bind:id="('general-help-'+index)" accordion="general-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text v-html="$t(help.answer)"></b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="help-section" v-show="helpStep===2">
              <div role="tablist">
                <b-card no-body class="mb-1" v-for="(help, index) in helpContent.gettingStarted" :key="index">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="('get-started-help-'+index)" v-html="$t(help.question)"></b-button>
                  </b-card-header>
                  <b-collapse v-bind:id="('get-started-help-'+index)" accordion="get-started-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text v-html="$t(help.answer)"></b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="help-section" v-show="helpStep===3">
              <div role="tablist">
                <b-card no-body class="mb-1" v-for="(help, index) in helpContent.investing" :key="index">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="('investing-help-'+index)" variant="secondary" v-html="$t(help.question)"></b-button>
                  </b-card-header>
                  <b-collapse v-bind:id="('investing-help-'+index)" accordion="investing-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text v-html="$t(help.answer)"></b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="help-section" v-show="helpStep===4">
              <div role="tablist">
                <b-card no-body class="mb-1" v-for="(help, index) in helpContent.security" :key="index">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="('security-help-'+index)" v-html="$t(help.question)"></b-button>
                  </b-card-header>
                  <b-collapse v-bind:id="('security-help-'+index)" accordion="security-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text v-html="$t(help.answer)"></b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="help-section" v-show="helpStep===5">
              <div role="tablist">
                <b-card no-body class="mb-1" v-for="(help, index) in helpContent.originator" :key="index">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="('originator-help-'+index)" v-html="$t(help.question)"></b-button>
                  </b-card-header>
                  <b-collapse v-bind:id="('originator-help-'+index)" accordion="originator-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text v-html="$t(help.answer)"></b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <help-schema/>
  </div>
</template>

<script>

import HelpSchema from '@/schema/HelpSchema'

export default {
  name: 'Help',
  components: {HelpSchema},
  data()
  {
    return {
      helpCategories: [{id: 1, title: 'views.help.generalCategory', active: true, completed: false},
        {id: 2, title: 'views.help.gettingStartedCategory', active: false, completed: false},
        {id: 3, title: 'views.help.investingCategory', active: false, completed: false},
        {id: 4, title: 'views.help.securityCategory', active: false, completed: false},
        {id: 5, title: 'views.help.loCategory', active: false, completed: false}
      ],
      helpStep: 1,
      helpContent: {
        general: [
          {
            question: 'views.help.whatIsTheIncome', answer: 'views.help.whatIsTheIncomeAnswer'
          },
          {
            question: 'views.help.howIsDifferentQ', answer: 'views.help.howIsDifferentA'
          },
          {
            question: 'views.help.areThereAnyFeesQ', answer: 'views.help.areThereAnyFeesA'
          },
          {
            question: 'views.help.whatAreTypicalReturnsQ', answer: 'views.help.whatAreTypicalReturnsA'
          }
        ],
        gettingStarted: [
          {
            question: 'views.help.whoCanInvestQ', answer: 'views.help.whoCanInvestA'
          },
          {
            question: 'views.help.howDoIStartQ', answer: 'views.help.howDoIStartA'
          },
          {
            question: 'views.help.whyIsIdentificationQ', answer: 'views.help.whyIsIdentificationA'
          },
          {
            question: 'views.help.howIsIdentificationQ', answer: 'views.help.howIsIdentificationA'
          },
          {
            question: 'views.help.problemWithVerificationQ', answer: 'views.help.problemWithVerificationA'
          },
          {
            question: 'views.help.howCanIDepositQ', answer: 'views.help.howCanIDepositA'
          },
          {
            question: 'views.help.howDoWithdrawQ', answer: 'views.help.howDoWithdrawA'
          },
          {
            question: 'views.help.whatIsAMinimumAmountQ', answer: 'views.help.whatIsAMinimumAmountA'
          },
          {
            question: 'views.help.howToEarnPassiveQ', answer: 'views.help.howToEarnPassiveA'
          },
          {
            question: 'views.help.howTIsDifferentOtherQ', answer: 'views.help.howTIsDifferentOtherA'
          }
        ],
        investing: [
          {
            question: 'views.help.whatDifferentOptionsQ', answer: 'views.help.whatDifferentOptionsA'
          },
          {
            question: 'views.help.howInterestCalculatedQ', answer: 'views.help.howInterestCalculatedA'
          },
          // {
          //   question: 'views.help.whyIsPrimaryMarketQ', answer: 'views.help.whyIsPrimaryMarketA'
          // },
          {
            question: 'views.help.whatIsSecondaryMarketQ', answer: 'views.help.whatIsSecondaryMarketA'
          },
          {
            question: 'views.help.whatIsAutoInvestQ', answer: 'views.help.whatIsAutoInvestA'
          },
          {
            question: 'views.help.whatIfIWantExitQ', answer: 'views.help.whatIfIWantExitA'
          },
          {
            question: 'views.help.howMyEarningsTaxedQ', answer: 'views.help.howMyEarningsTaxedA'
          },
          {
            question: 'views.help.whereLearnMoreQ', answer: 'views.help.whereLearnMoreA'
          }
        ],
        security: [
          {
            question: 'views.help.howDoesIMPrioritizeQ', answer: 'views.help.howDoesIMPrioritizeA'
          },
          {
            question: 'views.help.whatHappensQ', answer: 'views.help.whatHappensA'
          },
          {
            question: 'views.help.whatHappensIfLoanQ',
            answer: 'views.help.whatHappensIfLoanA'
          },
          {
            question: 'views.help.whatHappensIfOutQ',
            answer: 'views.help.whatHappensIfOutA'
          },
          {
            question: 'views.help.howInvestorsFundsQ',
            answer: 'views.help.howInvestorsFundsA'
          }
        ],
        originator: [
          {
            question: 'views.help.whatIsLOQ', answer: 'views.help.whatIsLOA'
          },
          {
            question: 'views.help.forWhatPurposesQ', answer: 'views.help.forWhatPurposesA'
          },
          {
            question: 'views.help.whoTheBorrowerIsQ', answer: 'views.help.whoTheBorrowerIsA'
          },
          {
            question: 'views.help.whereLearnMoreLOQ', answer: 'views.help.whereLearnMoreLOA'
          }
        ]
      }
    }
  },

  watch: {
    helpStep: function (number)
    {
      try
      {
        // Set completed previous steps
        this.helpCategories.filter(s => s.id < number).forEach(function (step)
        {
          step.active = false
        })
        // Set not active/completed next elements
        this.helpCategories.filter(s => s.id > number).forEach(function (step)
        {
          step.active = false
          step.completed = false
        })
        // Set active current selected step
        this.helpCategories.filter(s => s.id === number).shift().active = true
      }
      catch (e)
      {
        console.log('Something went wrong with changing helpCategories', e)
      }
    }
  },
  methods: {
    setHelpCategory(number)
    {
      this.helpStep = number
    }
  }
}
</script>

<style scoped lang="scss">

.help-section{
  .card .btn, .card .btn:hover, .card .btn:focus {
    @media (max-width: 600px) {
      font-size: 15px;
      max-height: initial;
    }
  }
}

.header-text {
  margin: 52px auto 16px;
  text-align: center;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 87px;
    text-align: left;
    color: #071D2D;
    flex: none;
    margin: auto auto 35px;

    .blue {
      color: #30A7FE;
    }
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.card {
  border: none;
  background: transparent;

  .btn-secondary, .btn-secondary:hover, .btn-secondary:focus {
    color: #000000;
    background-color: transparent;
    border-color: transparent;
  }

  .btn, .btn:hover, .btn:focus {
    text-align: left;
    box-shadow: none;
    padding-left: 25px;
    font-size: 20px;
  }

  .card-text {
    text-align: justify;
    //color: #071D2D;
    color: rgba(7, 29, 45, 0.8);
    font-size: 16px;
  }

  .card-header {
    background: transparent;
  }

  .collapsed {
    background: url('../assets/arrow_down.svg') left no-repeat;
    color: rgba(7, 29, 45, 0.5);
  }

  .not-collapsed {
    background: url('../assets/arrow_up.svg') left no-repeat;
    color: #071D2D;
  }
}
</style>
